import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type MatterPropertyDamage,
  type SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMatterPropertyDamageV3 = (
  data: Pick<MatterPropertyDamage, "matterId"> &
    Partial<Omit<MatterPropertyDamage, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterPropertyDamage>
    >("matters/v4/property-damages", data)
    .then((res) => res.data);
};

export const updateMatterPropertyDamageV1 = (
  data: Pick<MatterPropertyDamage, "id" | "matterId" | "dateModified"> &
    Partial<MatterPropertyDamage>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterPropertyDamage>
    >(`${baseFastApiMatterRoute}/property-damages`, data)
    .then((res) => res.data);
};

export const deleteMatterPropertyDamageV1 = (
  data: Pick<MatterPropertyDamage, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterPropertyDamage>
    >(`${baseFastApiMatterRoute}/property-damages/${id}`)
    .then((res) => res.data);
};
